import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, unref, onUnmounted, onMounted } from 'vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'BackToTop',
  setup(__props) {

  const show = ref(false);

  function handleScroll() {
    const showVal = unref(show);
    const { pageYOffset } = window;
    if ((!showVal && pageYOffset > 100) || (showVal && pageYOffset === 0)) {
      show.value = !showVal;
    }
  }

  onMounted(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
  });

  onUnmounted(() => {
    window.removeEventListener('scroll', handleScroll);
  });

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("a", {
    href: "#",
    id: "back-to-top",
    class: _normalizeClass({ show: show.value }),
    "aria-label": "Back to top"
  }, [
    _createVNode(_component_font_awesome_icon, { icon: "angle-double-up" })
  ], 2))
}
}

})